import { ColDef, ICellRendererParams } from 'ag-grid-community'
import { Group } from '@/types'
import { Pencil, Trash } from 'phosphor-react'

interface GroupsColumnDefsParams {
  handleEdit: (group: Group) => void
  handleDeleteClick: (id: string) => void
  canEdit: boolean
}

export const getGroupsColumnDefs = ({
  handleEdit,
  handleDeleteClick,
  canEdit,
}: GroupsColumnDefsParams): ColDef[] => {
  const columns: ColDef[] = [
    {
      headerName: 'Nom',
      field: 'name',
      flex: 1,
      minWidth: 200,
    },
    {
      headerName: 'Date de création',
      field: 'createdAt',
      flex: 1,
      minWidth: 180,
      filter: 'agDateColumnFilter',
      valueFormatter: params => {
        if (!params.value) return ''
        return new Date(params.value).toLocaleDateString('fr-FR', {
          year: 'numeric',
          month: 'long',
          day: 'numeric',
        })
      },
    },
    {
      headerName: 'Dernière modification',
      field: 'updatedAt',
      flex: 1,
      minWidth: 180,
      filter: 'agDateColumnFilter',
      valueFormatter: params => {
        if (!params.value) return ''
        return new Date(params.value).toLocaleDateString('fr-FR', {
          year: 'numeric',
          month: 'long',
          day: 'numeric',
        })
      },
    },
  ]

  const actionsColumn: ColDef = {
    headerName: 'Actions',
    width: 150,
    sortable: false,
    filter: false,
    cellRenderer: (params: ICellRendererParams) => (
      <div className="flex items-center gap-2 h-full">
        <button
          onClick={() => handleEdit(params.data)}
          className="flex items-center justify-center w-8 h-8 rounded-lg text-[var(--color-primary)] hover:bg-[var(--color-primary)]/10 transition-all duration-200"
          title="Modifier"
        >
          <Pencil className="w-4 h-4" weight="regular" />
        </button>
        <button
          onClick={() => handleDeleteClick(params.data._id)}
          className="flex items-center justify-center w-8 h-8 rounded-lg text-[var(--color-error)] hover:bg-[var(--color-error)]/10 transition-all duration-200"
          title="Supprimer"
        >
          <Trash className="w-4 h-4" weight="regular" />
        </button>
      </div>
    ),
    pinned: 'right',
  }

  // Only add actions column if user can edit
  if (canEdit) {
    columns.push(actionsColumn)
  }

  return columns
}
